import {DependencyList, EffectCallback, useEffect} from "react";

export default function useWindow(callback: EffectCallback, dependencies : DependencyList | undefined = []) {
    if(typeof window !== "undefined"){
        useEffect(callback,dependencies);
    }
}